import { BellFilled } from '@ant-design/icons'
import { Badge, Drawer, Popover, Tooltip } from 'antd'
import React, { useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'
import { useNotifications } from './context'
import { NotificationCenterPanel } from './notification-center-panel'

const SYSTEM_BUTTON_COLOR = 'var(--system-button, var(--system-primary, #1677ff))'

const BellButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border: 1px solid ${SYSTEM_BUTTON_COLOR};
  border-radius: 8px;
  background: ${SYSTEM_BUTTON_COLOR};
  color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s, transform 0.2s;

  &:hover {
    color: #fff;
    border-color: color-mix(in srgb, ${SYSTEM_BUTTON_COLOR} 86%, #000);
    background: color-mix(in srgb, ${SYSTEM_BUTTON_COLOR} 86%, #000);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.14);
  }

  &:active {
    transform: translateY(1px);
  }

  &:focus-visible {
    outline: 2px solid var(--system-focus, ${SYSTEM_BUTTON_COLOR});
    outline-offset: 2px;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`

export const NotificationBell = () => {
  const [open, setOpen] = useState(false)
  const isMobile = useMediaQuery({ maxWidth: 768 })
  const { hasRoleNotificationAccess, settingsLoaded, unreadCount } = useNotifications()

  if (!settingsLoaded || !hasRoleNotificationAccess) {
    return null
  }

  const button = (
    <Tooltip title="Уведомления">
      <Badge count={unreadCount} size="small" overflowCount={99}>
        <BellButton type="button" onClick={() => setOpen(true)} aria-expanded={open}>
          <BellFilled />
        </BellButton>
      </Badge>
    </Tooltip>
  )

  if (isMobile) {
    return (
      <>
        {button}
        <Drawer
          title="Уведомления"
          placement="right"
          width="100%"
          open={open}
          onClose={() => setOpen(false)}
          zIndex={1200}
        >
          <NotificationCenterPanel onClose={() => setOpen(false)} />
        </Drawer>
      </>
    )
  }

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      open={open}
      onOpenChange={setOpen}
      content={<NotificationCenterPanel onClose={() => setOpen(false)} />}
      overlayInnerStyle={{ padding: '0 16px 16px' }}
    >
      {button}
    </Popover>
  )
}
